import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Parallax, Background } from 'react-parallax';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

import backgroundImage from '../images/terracina-broomfield-apartments-pool.jpg'

export default (props) => {

  const paddingTop = props.paddingTop;

  return (
    <section 
      className="section section--dark section--shadowed" 
      style={{
        "--section-min-height": "60vh", 
        "--section-padding-top": paddingTop
      }}>
      <Parallax strength={200}>
        <Background className="custom-bg">
          <img src={backgroundImage} style={{width: "100%"}} />
        </Background>
        <Container>
          <div className="section__content">
            <h2 className="kh-h2 kh-h2--xxl text-center">
              {props.headline.smallCopy &&
                <>
                  <span className="kh-h2__secondary">{props.headline.smallCopy}</span> <br />
                </>
              }
              {props.headline.largeCopy}
            </h2>
            <Row>
              <Col lg={8} className="text-center">
        
                <Row>
                    {props.stats.map((object) => (
                      <Col md={4}>
                        <div className="data">
                          <div className="data__label">{object.label}</div>
                          <div className="data__value">
                            <CountUp end={parseFloat(object.value)} redraw={true} decimals={1}>
                              {({ countUpRef, start }) => (
                                <VisibilitySensor onChange={start} delayedCall>
                                  <>
                                    <span ref={countUpRef} />%
                                  </>
                                </VisibilitySensor>
                              )}
                            </CountUp>
                          </div>
                        </div>
                      </Col>
                    )
                  )}
                </Row>
        
                <p className="data-title mt-4">
                  {props.statsHeadline.largeCopy &&
                    <>
                      {props.statsHeadline.largeCopy}<br />
                    </>
                  }
                  <span className="data-title__secondary">{props.statsHeadline.smallCopy}</span>
                </p>
              </Col>
              <Col lg={4}>
                <div dangerouslySetInnerHTML={{__html: props.content}} />
              </Col>
            </Row>
          </div>
        </Container>
      </Parallax>
    </section>
  )
}